// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__19wCT","mobileMenu":"Footer_mobileMenu__32WJs","footerLogo":"Footer_footerLogo__7UHFh","footerContainer":"Footer_footerContainer__3xt5X"};